import { render } from "./SearchableSelect.vue?vue&type=template&id=0b20ae64&scoped=true"
import script from "./SearchableSelect.vue?vue&type=script&lang=js"
export * from "./SearchableSelect.vue?vue&type=script&lang=js"

import "./SearchableSelect.vue?vue&type=style&index=0&id=0b20ae64&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b20ae64"]])

export default __exports__